import api from "../apiInstance";
import { ContactForm } from "./interfaces/ContactForm";
import { PaginatedListResponse } from "./interfaces/paging";
import { CreateProductModel, CreateProductResponse, DateIntervalModel, PorductSearchFilters, ProductAvailabilityAndDateResponse, ProductEditResponse, ProductListResponse, UpdateProductModel } from "./interfaces/Product";

export interface EmailSentResponse {
    success: boolean,
    message: string
}

export const sendContactMail = async (data: ContactForm) => {
    const res = await api.post(process.env.REACT_APP_RENTIC_API_URL! + '/contact/send_contact_mail', data);
    return res;
}